<h2 mat-dialog-title>Usuwanie karty planowanej</h2>
<div mat-dialog-content>Czy na pewno chcesz usunąć wybraną kartę?</div>

<div mat-dialog-actions>
  <button mat-flat-button (click)="dialogRef.close(false)">Anuluj</button>
  <button mat-flat-button color="primary" (click)="approve()">Zatwierdź</button>
</div>
